import {EMPTY_STORE, WRITE_TEXT_ACTIVE, DELETE_WRITE_TEXT, SET_WRITE_TEXT_POSITION} from "../_types";

const initialState = {
    writeTexte: undefined,
    position: null,
}

const writeTextReducer = (state = initialState , action) => {
    switch (action.type) {
        case WRITE_TEXT_ACTIVE:
            return {
                ...state,
                writeTexte: action.payload
            }
        case DELETE_WRITE_TEXT:
            return {
                ...state,
                writeTexte: undefined,
            };
        case EMPTY_STORE:
            return initialState;
        case SET_WRITE_TEXT_POSITION:
            return {
                ...state,
                position: action.payload
            };
        default :
            return {...state};
    }
}

export default writeTextReducer;